/** Supported package / payout currencies (ISO 4217). */
export const PACKAGE_CURRENCIES = ['EUR', 'USD', 'GBP'] as const;

export type PackageCurrency = (typeof PACKAGE_CURRENCIES)[number];

export function majorToCents(amount: number): number {
  if (!Number.isFinite(amount) || amount < 0) {
    return 0;
  }
  return Math.round(amount * 100);
}

export function centsToMajor(cents: number): number {
  if (!Number.isFinite(cents)) {
    return 0;
  }
  return Math.round(cents) / 100;
}

export function formatMoney(cents: number, currency = 'EUR'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.length === 3 ? currency : 'EUR',
    minimumFractionDigits: 2,
  }).format(cents / 100);
}
